module.exports = __webpack_public_path__ + "static/media/screenshot2_new.85c6691d.png";